{
    "common": {
        "mon": "Sen",
        "tue": "Sel",
        "wed": "Rab",
        "thu": "Kam",
        "fri": "Jum",
        "sat": "Sab",
        "sun": "Min",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ags",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Des",
        "january": "Januari",
        "february": "Februari",
        "march": "Maret",
        "april": "April",
        "may": "Mei",
        "june": "Juni",
        "july": "Juli",
        "august": "Agustus", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Desember",
        "checkin": "Check-In",
        "checkout": "Check-Out",
        "room": "Kamar",
        "rooms": "Kamar",
        "adult": "Dewasa",
        "adults": "Dewasa",
        "edit": "Edit",
        "editCap": "EDIT",
        "delete":"Hapus",
        "deleteCap":"HAPUS",
        "localTime": "Waktu Lokal",
        "back": "KEMBALI",
        "home": "BERANDA",
        "yes": "YA",
        "no": "TIDAK",
        "left": "Tersisa",
        "hour": "Jam",
        "hours": "Jam",
        "night": "malam",
        "nights": "malam",
        "for": "untuk",
        "why": "Mengapa",
        "get": "Dapatkan",
        "more": "Lebih",
        "agree": "SETUJU",
        "disagree": "TIDAK SETUJU",
        "basedOn": "berdasarkan",
        "error": "Terjadi kesalahan, silakan coba lagi nanti",
        "error2": "Gagal, coba lagi!",
        "error3": "Terjadi Kesalahan!!",
        "error4": "Terjadi kesalahan!! Silakan coba lagi",
        "error5": "Maaf!! Terjadi kesalahan. Silakan coba lagi setelah beberapa saat.",
        "hi": "Hai",
        "to": "ke",
        "free": "Gratis",
        "per": "Per",
        "at": "pada",
        "day": "Hari",
        "days": "Hari",
        "time": "Waktu",
        "of": "dari",
        "photo": "Foto",
        "photos": "Foto",
        "done": "Selesai",
        "fullStay": "Menginap Penuh",
        "date": "Tanggal",
        "and": "dan",
        "bookingDetail": "Detail Pemesanan",
        "Back": "Kembali",
        "Home": "Beranda"
    },
    "userPopup":{
        "myAccount": "Akun Saya",
        "welcome": "Selamat Datang",
        "user": "Pengguna",
        "findMyBookings": "TEMUKAN PEMESANAN SAYA",
        "viewProfile": "LIHAT PROFIL",
        "makeAReservarion": "BUAT PEMESANAN",
        "logout": "KELUAR",
        "loginCap": "MASUK",
        "login": "Masuk",
        "invalidCredentials": "Kredensial tidak valid",
        "invalidEmail": "Email tidak valid",
        "passwordIsRequired": "Kata sandi diperlukan",
        "minChar8":"minimal 8 karakter",
        "tooShort": "Terlalu Pendek!",
        "tooLong": "Terlalu Panjang!",
        "required": "Diperlukan",
        "emailInvalid":"Masukkan email yang valid",
        "passwordInvalid":"Masukkan kata sandi yang valid",
        "phNumInvalid": "Nomor telepon tidak valid",
        "signupCap": "DAFTAR",
        "signup": "Daftar",
        "verifyText":"Verifikasi bahwa itu adalah Anda",
        "verifyText2":"Kami mengirim kode verifikasi ke email Anda",
        "verificationCode":"Kode Verifikasi",
        "didNotReceiveEmail": "Tidak menerima email",
        "clickToResend": "Klik untuk kirim ulang",
        "verifyAndSignIn": "Verifikasi dan Masuk",
        "otpSentSuccessfully": "OTP berhasil dikirim",
        "somethingWentWrong":  "Terjadi kesalahan, silakan coba lagi",
        "otpError": "Silakan masukkan nomor yang valid",
        "otpError2":"Silakan masukkan angka saja",
        "otpError3": "OTP tidak benar, silakan coba lagi",
        "otpError4": "OTP Kedaluwarsa, klik Kirim Ulang untuk coba lagi",
        "otpError5": "Silakan coba lagi",
        "forgetPassword": "Lupa Kata Sandi",
        "submitError": "Pengguna tidak ada!",
        "userExistError": "Pengguna Sudah Ada",
        "checkYourEmail":  "Periksa email Anda",
        "passwordResetLinkSent": "Kami telah mengirim tautan reset kata sandi ke",
        "noWorriesResetInstructions": "Jangan khawatir, kami akan kirim instruksi reset kepada Anda.",
        "enterYourEmail": "Masukkan email Anda",
        "resetMyPassword": "RESET KATA SANDI SAYA",
        "setANewPassword": "Atur kata sandi baru",
        "newPassword": "Kata Sandi Baru",
        "confirmPassword": "Konfirmasi Kata Sandi",
        "confirmPasswordError": "Kata sandi harus cocok",
        "backToLogin": "Kembali ke Masuk",
        "dontHaveAccount": "Tidak punya akun?",
        "alreadyHaveAccount": "Sudah punya akun?",
        "memberDiscount1": "Anda akan mendapat",
        "memberDiscount2": "diskon member selamanya.",
        "discount1": "Kelola semua pemesanan Anda dari satu tempat.",
        "discount2": "Daftar untuk rekomendasi pribadi dan pengalaman yang disesuaikan!!",
        "discount3": "Bergabunglah dengan komunitas tamu bahagia kami dan mulai merencanakan menginap Anda.",
        "leftGridText1": "Kelola semua pemesanan Anda dari satu tempat",
        "leftGridText2": "Daftar untuk rekomendasi pribadi dan pengalaman yang disesuaikan!!",
        "leftGridText3": "Bergabunglah dengan komunitas tamu bahagia kami dan mulai merencanakan menginap Anda",
        "gridDiscountText1": "diskon member untuk",
        "gridDiscountText2": "properti pilihan selamanya",
        "gridDiscountText3": "Masuk untuk pengalaman yang disesuaikan selamanya",
        "gridDiscountText4": "Dapatkan Manfaat Member Eksklusif",
        "findBookingError": "Email dan id pemesanan Anda tidak cocok",
        "verifyAndConfirmBooking":"Verifikasi dan konfirmasi pemesanan",
        "confirmEmailText": "Kami telah mengirim kode verifikasi ke alamat email Anda",
        "enterCodeText":"Silakan masukkan kode verifikasi yang dikirim kepada Anda",
        "didNotRecieveEmail": "Tidak menerima email?",
        "changeEmailText": "Klik di sini untuk mengubah alamat email",
        "verifyAndConfirm": "Verifikasi dan Konfirmasi",
        "verified": "TERVERIFIKASI",
        "bookingExpired": "Pemesanan Kedaluwarsa",
        "bookingExpiredText": "Kami minta maaf, id pemesanan yang Anda gunakan telah kedaluwarsa",
        "backToFindingBooking": "Kembali ke Temukan Pemesanan",
        "findMyBooking": "Temukan Pemesanan Saya",
        "bookingEmail": "Email Pemesanan",
        "reservationId": "Id Pemesanan",
        "findBooking": "TEMUKAN PEMESANAN",
        "abandonmentCartDoneText1": "Terima kasih!",
        "abandonmentCartDoneText2":"Detail keranjang Anda telah dikirim ke email. Lanjutkan pemesanan Anda kapan saja.",
        "Recommended Currencies": "Mata Uang yang Direkomendasikan",
        "All currencies": "Semua mata uang",
        "thisIsRequiredField": "Ini adalah bidang yang diperlukan"
    },
    "widget":{
        "destination": "Destinasi",
        "enterDestination": "Masukkan Destinasi",
        "guests": "Tamu",
        "nationality": "Kewarganegaraan",
        "selectNationality": "Pilih kewarganegaraan",
        "nationalityIsRequired": "Kewarganegaraan wajib diisi",
        "selectedRate": "Tarif khusus",
        "search": "Cari",
        "ages": "Usia",
        "orAbove": "Atau Lebih",
        "child": "Anak",
        "children": "Anak",
        "addAnotherRoom": "Tambah Kamar Lain",
        "removeRoom": "Hapus Kamar",
        "property": "Properti",
        "city": "Kota",
        "country": "Negara",
        "bookNow": "Pesan Sekarang",
        "overnightStay": "Menginap Semalam",
        "dayUse": "Penggunaan Harian",
        "destinationIsRequired": "Destinasi diperlukan",
        "checkInIsRequired": "Tanggal check-in diperlukan",
        "checkOutIsRequired": "Tanggal check-out diperlukan",
        "noLocationFound": "Lokasi Tidak Ditemukan",
        "soldOut": "Habis terjual",
        "highDemand": "Permintaan Tinggi",
        "dates": "Tanggal",
        "allRates": "Semua tarif dalam",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Check-out hari yang sama"
    },
    "promotion": {
        "headingText": "Informasi Penting untuk",
        "regularRate": "Tidak ada",
        "seniorCitizen": "Tarif Warga Senior",
        "agencyRate": "Tarif Agen",
        "caaRate": "Tarif CAA/AAA",
        "corporateRate": "Tarif Korporat",
        "governmentRate": "Tarif Pemerintah/Militer",
        "promotionalSpecialRate": "Tarif Promosi/Khusus",
        "regularRateDescription": "Tidak ada promosi yang diterapkan.",
        "seniorCitizenRateDescription": "Ini adalah tarif hotel diskon yang tersedia secara luas untuk orang dewasa yang lebih tua, biasanya berusia 60 tahun ke atas.",
        "agencyRateDescription": "Ini adalah tarif hotel diskon yang ditawarkan yang dapat diakses melalui agen perjalanan tertentu saja untuk mendorong kemitraan dan kolaborasi.",
        "caaRateDescription": "Ini adalah tarif hotel khusus yang ditawarkan kepada anggota AAA atau CAA untuk penghematan eksklusif.",
        "corporateRateDescription": "Ini adalah tarif hotel diskon yang diperluas untuk pelancong bisnis, biasanya dinegosiasikan antara hotel dan entitas korporat.",
        "governmentRateDescription": "Paket tarif ini menawarkan diskon khusus untuk personel Pemerintah/Militer untuk memesan kamar hotel.",
        "contentSeniorCitizen": "Bukti tanggal lahir wajib pada saat check-in. Kegagalan untuk menyerahkan ID yang relevan akan mengakibatkan dikenakan tarif yang berlaku.",
        "contentAgencyRate": "Pastikan Anda memiliki konfirmasi pemesanan dan bukti ID saat kedatangan. Kegagalan untuk menyerahkan ini akan mengakibatkan tarif standar dikenakan.",
        "contentPromotionalSpecialRate": "Ini adalah tarif hotel diskon yang ditawarkan untuk waktu terbatas, sering kali terkait dengan acara, musim, atau kampanye pemasaran tertentu.",
        "contentCaaRate": "Silakan pastikan Anda memiliki kartu keanggotaan CAA atau identifikasi yang relevan pada saat check-in. Kegagalan untuk menyerahkan ID yang relevan akan mengakibatkan dikenakan tarif yang berlaku.",
        "contentCorporateRate": "Bukti ID perusahaan atau dokumentasi resmi lainnya diperlukan pada saat check-in. Kegagalan untuk menyerahkan bukti yang relevan akan mengakibatkan dikenakan tarif yang berlaku.",
        "contentGovernmentRate": "ID pemerintah atau militer yang valid harus disediakan saat check-in. Kegagalan untuk menyediakan identifikasi yang diperlukan akan mengakibatkan dikenakan tarif standar.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "TERAPKAN",
        "Offer Code": "Kode Penawaran",
        "Agency Code": "Kode Agen",
        "Corporate Code": "Kode Korporat",
        "All-Access Rate": "Tarif Akses Semua",
        "errorCode": "Kode ini tidak valid"
    }
} 